import React from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';

export default function RankingTable({ columns, data, renderRow }) {
    return (
        <Table>
            <thead>
                <tr>
                    {columns.map((col, i) => (
                        <Th key={i} align={col.align}>{col.label}</Th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => renderRow(item, index))}
            </tbody>
        </Table>
    );
}

export const Td = styled.td`
    padding: 14px 0;
    font-size: 14px;
    color: ${colors.nightDark};
    border-bottom: 1px solid #f5f5f5;
    text-align: ${({ align }) => align || 'left'};
`;

export const TdBold = styled(Td)`
    font-weight: 600;
`;

export const TdSmall = styled.span`
    display: block;
    font-size: 12px;
    color: ${colors.night};
    margin-top: 2px;
`;

export const Badge = styled.span`
    background: ${({ bg }) => bg || '#F3E8FF'};
    color: ${({ color }) => color || colors.secondaryPurple};
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

const Th = styled.th`
    text-align: ${({ align }) => align || 'left'};
    font-size: 12px;
    color: ${colors.night};
    font-weight: 500;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;
